import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { fetchNotifications, fetchNotificationsCount, NotificationMarkAsViewed } from "./asyncThunkAPI";

/**
 * @author Aston Kingsley 
 */
const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    clearNotifications: (state) => {
      state.count = 0;
    },

    /**
     * if the count fetching api is success we will get new count 
     * The new count is arived it will be set to count state
     * @param {*} state 
     * @param {*} action 
     */
    notificationSuccess: (state, action) => {
      state.count = state.count + action.payload;
      state.error = null;
    },

    updateNotificationList: (state, action) => {
      state.notifications = action.payload
    },

    toggleNotification: (state,action) => {
      state.hasNotifications = action.payload
    },
    
    /**
     * if the count fetching has any errors that will handled here
     * @param {*} state 
     * @param {*} action 
     */
    notificationError: (state, action) => {
      state.error = action.payload;
    },

    /**
     * function to open alert if the count changes
     * if a the count changes alert will show that will notify user
     * @param {*} state 
     * @param {*} actions 
     */
    handleAlertOpenClose: (state, actions) => {
      state.openAlert = actions.payload;
    },

    /**
     * function to clear all notification that is currently in the list
     * @param {*} state 
     */
    clearAllNotification: (state) => {
      state.notifications = [];
      state.hasNotifications = false;
      state.unreadCount = 0;
      state.count = 0;
    },
    clearAllState: () => initialState
  },

  extraReducers: (builder) => {
    builder.addCase(fetchNotifications.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchNotifications.fulfilled, (state,action) => {
      state.loading = false
      state.notifications = action.payload.results
      if (action.payload.results.length == 0 ) {
        state.hasNotifications = false
      }
    });

    builder.addCase(fetchNotifications.rejected, (state) => {
      state.loading = false
      state.notifications = []
    });

    builder.addCase(fetchNotificationsCount.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(fetchNotificationsCount.fulfilled, (state,action) => {
      const {count} = action.payload
      state.loading = false;
      state.count = count;
    });

    builder.addCase(fetchNotificationsCount.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(NotificationMarkAsViewed.pending, (state) => {
      state.loading = true;
    })
    builder.addCase(NotificationMarkAsViewed.fulfilled, (state,action) => {
      state.loading = false;
      state.count =  action.payload?.count;
    })
    builder.addCase(NotificationMarkAsViewed.rejected, (state) => {
      state.loading = false;
    })
  }
});

export const { clearNotifications,toggleNotification,updateNotificationList,
  notificationSuccess, notificationError, clearAllNotification, handleAlertOpenClose,
} = notificationSlice.actions;
export default notificationSlice.reducer;
